import { jsxs as o, jsx as a } from "react/jsx-runtime";
import { c as r } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const w = ({
  value: s,
  max: e = 100,
  variant: i = "default",
  size: d = "md",
  showLabel: t = !1,
  className: c,
  "aria-label": n,
  "aria-labelledby": m,
  ...u
}) => {
  const l = Math.min(Math.max(s / e * 100, 0), 100), b = {
    default: "bg-[var(--ds-color-bg-primary)]",
    success: "bg-[var(--ds-color-bg-success)]",
    warning: "bg-[var(--ds-color-bg-warning)]",
    error: "bg-[var(--ds-color-bg-danger)]"
  }, g = {
    sm: "h-1",
    md: "h-2",
    lg: "h-4"
  };
  return /* @__PURE__ */ o("div", { className: r("w-full", c), ...u, children: [
    /* @__PURE__ */ a("div", { className: "flex justify-between mb-1", children: t && /* @__PURE__ */ o("span", { className: "text-xs font-medium text-[var(--ds-color-fg-default)]", children: [
      Math.round(l),
      "%"
    ] }) }),
    /* @__PURE__ */ a("div", { className: r("w-full overflow-hidden rounded-[var(--ds-radius-full)] bg-[var(--ds-color-bg-surface-active)]", g[d]), children: /* @__PURE__ */ a(
      "div",
      {
        className: r("h-full transition-all duration-300 ease-in-out", b[i]),
        style: { width: `${l}%` },
        role: "progressbar",
        "aria-valuenow": s,
        "aria-valuemin": 0,
        "aria-valuemax": e,
        "aria-label": n || "Progress",
        "aria-labelledby": m
      }
    ) })
  ] });
};
export {
  w as P
};
